<!--
<custom-time :deadline="1653296511779" />

import Time from '@/views/index/components/Time.vue'
components: {
  'custom-time': Time
}
-->

<template>
  <div class="time-comp f--c">
    <template v-if="day > 0">
      <div class="block" style="width: auto; padding: 0 10px;">
        {{day}}
        <span style="font-size: 18px;">{{ $t('Index.Components.Time.Days') }}</span>
      </div>
      <div class="colon"></div>
    </template>
    <div v-for="(item,index) in hours" :key="index" class="block">{{item}}</div>
    <div class="colon">
      <div class="circular" style="margin-bottom: 5px;"></div>
      <div class="circular"></div>
    </div>
    <div class="block">{{time[0]}}</div>
    <div class="block">{{time[1]}}</div>
    <div class="colon">
      <div class="circular" style="margin-bottom: 5px;"></div>
      <div class="circular"></div>
    </div>
    <div class="block">{{time[2]}}</div>
    <div class="block">{{time[3]}}</div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)
export default {
  props: {
    // 截止时间时间戳（毫秒）
    deadline: {
      type: Number,
      require: true,
      default: 0
    }
  },
  data() {
    return {
      day: 0,
      time: '0000',
      hours: '00'
    }
  },
  created() {
    const timer = setInterval(() => {
      const current = new Date().getTime()
      const time = this.deadline - current
      if (time <= 0) {
        this.day = 0
        this.time = '0000'
        return clearInterval(timer)
      }
      const day = parseInt(dayjs.tz(time, 'GMT').format('DD')) - 1
      const timeStr = dayjs.tz(time, 'GMT').format('HHmmss')
      let hours = String(parseInt(timeStr.slice(0, 2)) + day * 24)
      if (hours.length === 1) hours = '0' + hours
      this.hours = hours
      this.time = timeStr.slice(2)
    }, 1000)

    this.$once('hook:beforeDestroy', () => {
      clearInterval(timer)
    })
  }
}
</script>

<style lang="scss" scoped>
.time-comp{
  .block{
    width: 34px;
    height: 41px;
    background: black;
    color: white;
    text-align: center;
    line-height: 41px;
    border-radius: 2px;
    margin-right: 1px;
    font-size: 22px;
    font-weight: 600;
  }
  .colon{
    height: 41px;
    width: 11px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.circular{
  width: 4px;
  height: 4px;
  border-radius: 100px;
  background: black;
}
</style>
